export enum ControlReportValues {
  IN_FILE = 'inFile',
  UPLOAD_ICR = 'uploadIcr',
  NO_ICR = 'noIcr',
}
